import { isEmpty } from 'lodash';
import { RRule, Weekday } from 'rrule';

export function matchesWeekday(rule: RRule | undefined, day: Weekday): boolean {
  return (
    !isEmpty(rule) &&
    // @ts-expect-error -- strict migration
    rule.options.freq === RRule.WEEKLY &&
    // @ts-expect-error -- strict migration
    rule.options.byweekday.includes(day.weekday)
  );
}
